import logo from "../../assets/logos/instra-white.png";
import { Email, Phone, LogoLinkedin, LogoYoutube, LogoTwitter, LogoFacebook } from "@carbon/icons-react";
import { Column, Grid, Stack } from "@carbon/react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  selectBrandDisplayName,
  selectBrandLogoUrl,
} from "../../features/branding/brandingSlice";

const FooterLayout = () => {
  const { t } = useTranslation();
  const brandDisplayName = useSelector(selectBrandDisplayName);
  const brandLogoUrl = useSelector(selectBrandLogoUrl);
  const footerLogo = brandLogoUrl || logo;
  const brandName = brandDisplayName || "MakeMake";

  return (
  <footer className="app-footer">
    <Grid fullWidth className="app-footer__main">
      <Column lg={4} md={4} sm={4}>
        <img
          className="img-footer-logo"
          src={footerLogo}
          alt={brandName}
          onError={(event) => {
            event.currentTarget.src = logo;
          }}
        />
      </Column>

      <Column lg={4} md={4} sm={4}>
        <Stack gap={3}>
          <h2>{t("footer.contact")}</h2>
          <p><Phone size={16} /> +34-*********</p>
          <p><Email size={16} /> <a href="mailto:support@possible.com">support@possible.com</a></p>
        </Stack>
      </Column>

      <Column lg={4} md={4} sm={4}>
        <Stack gap={3}>
          <h2>{t("footer.socialNetworks")}</h2>
          <div className="app-footer__social">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
              <LogoFacebook size={24} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
              <LogoTwitter size={24} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube">
              <LogoYoutube size={24} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <LogoLinkedin size={24} />
            </a>
          </div>
        </Stack>
      </Column>

      <Column lg={4} md={4} sm={4}>
        <Stack gap={3}>
          <h2>FAQ</h2>
          <a href="#faq">{t("footer.faq")}</a>
        </Stack>
      </Column>
    </Grid>

    <Grid fullWidth className="app-footer__bar">
      <Column lg={8} md={4} sm={4}>
        <p>{t("footer.copyright", { year: new Date().getFullYear(), brand: brandName })}</p>
      </Column>
      <Column lg={8} md={4} sm={4} className="app-footer__powered">
        <p>{t("footer.poweredBy")}</p>
      </Column>
    </Grid>
  </footer>
  );
};

export default FooterLayout;
